export default __webpack_public_path__ + "static/media/plus.383b6ac3.svg";